import { useSignal } from "@preact/signals-react";
import { useQuery } from "@tanstack/react-query";

import { layout as modelFolio } from "./models/modelFolio";
import CardRoom from "./CardRoom";
import SearchBar from "components/Tools/SearchBar";
import GridCardsNew from "components/Card/GridCardsNew";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import funcs from "tools/functions";

function ActiveRooms() {
  const wordsSearch = useSignal(null);
  const session = getStorage("ctxSession");

  async function getFolios() {
    const layout = await modelFolio(CardRoom);
    const fieldsNames = funcs.getViewFields(layout, "form");
    fieldsNames.push("room.code");
    const orderBy = [["room.code", "ASC"]];
    const dom = [
      ["registration_state", "=", "check_in"],
      ["booking.environment", "=", session.shop],
    ];
    if (wordsSearch.value) {
      dom.push(["room.name", "ilike", `%${wordsSearch.value}%`]);
    }

    const { data } = await proxy.search(
      "hotel.folio",
      dom,
      fieldsNames,
      null,
      orderBy,
    );
    return data;
  }

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["folios"],
    queryFn: getFolios,
  });

  function handleSearch(value) {
    wordsSearch.value = value;
    if (wordsSearch.value && wordsSearch.value.length < 2) {
      return;
    }
    refetch();
  }

  const field = {
    style: "",
    ctxView: null,
  };

  const attrs = {
    level: "main",
  };

  return (
    <div className="w-1/5 lg:w-2/5 bg-neutral-100 px-4">
      <div className="flex mb-4">
        <span className="mx-auto font-extrabold text-neutral-700 text-3xl mt-4">
          HABITACIONES
        </span>
      </div>
      <SearchBar
        handleSearch={handleSearch}
        color="bg-white"
        autoSearch={true}
        size="w-2/3 mb-8"
      />
      {!isLoading && data && (
        <GridCardsNew field={field} attrs={attrs} data={data} />
      )}
    </div>
  );
}

export default ActiveRooms;
